import {
  useDataProvider,
  useLocalization,
  useSnackbar,
} from '@ui-framework/index';
import {
  ButtonContainer,
  IconLibrary,
  PageSection,
  PermissionButton,
} from '@product-framework/index';
import Form from '@product-framework/components/AdvancedForms/Form';
import { useCallback, useRef } from 'react';
import { observer } from 'mobx-react';
import schema from './edit.json';
import validationSchema from './validations';
import { useServiceProviderScope } from '../../scope';

const FORM_ID = 'EditServiceProviderNewLocationForm';
const PERMISSION_SP = 'SERVICEPROVIDERPROFILE';

function Perfomance({ onChange = () => undefined }) {
  const { formatMessage } = useLocalization();
  const formRef = useRef();
  const snackbar = useSnackbar();
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { get, put } = useDataProvider(provider);
  const { serviceProviderId, endpoints } = useServiceProviderScope();

  const { performanceApiUrl: apiUrl } = endpoints;

  const fetchDefaultValues = useCallback(async () => {
    const response = await get(apiUrl);
    if (response?.ok) {
      const result = {
        data: response?.data,
        errors: null,
      };

      return result;
    }
    const result = {
      data: null,
      errors: response?.errors,
    };
    return result;
  }, [serviceProviderId]);

  const onSubmit = async data => {
    const response = await put(apiUrl, { ranking: data.ranking });

    if (response?.ok) {
      snackbar.showMessage(
        formatMessage({
          id: 'SERVICEPROVIDER_PERFORMANCE_SAVE_SUCCESS',
          defaultMessage:
            'Service Provider performance were saved successfully',
        }),
      );
      return {
        nextValues: response?.data,
        errors: null,
        callback: () => {
          onChange();
        },
      };
    }
    return {
      nextValues: data,
      errors: response?.errors,
    };
  };

  return (
    <PageSection
      label={formatMessage({
        id: 'SERVICE_PROVIDER_PERFORMANCE_EDIT_HEADING',
        defaultMessage: 'Performance',
      })}>
      <Form
        formId={FORM_ID}
        ref={formRef}
        permissionEntities={[PERMISSION_SP]}
        onSubmit={onSubmit}
        schema={schema}
        fetchDefaultValues={fetchDefaultValues}
        validationSchema={validationSchema(formatMessage)}>
        <ButtonContainer>
          <PermissionButton
            variant="contained"
            permissionName="CAN_UPDATE_SP_PERFORMANCE"
            startIcon={<IconLibrary.Save />}
            color="primary"
            onClick={() => formRef.current?.submit({ formId: FORM_ID })}>
            {formatMessage({
              id: 'SERVICEPROVIDER_EDIT_SAVE_PERFORMANCE_BUTTON',
              defaultMessage: 'Save Performance',
            })}
          </PermissionButton>
          <PermissionButton
            permissionName="CAN_UPDATE_SP_PERFORMANCE"
            variant="contained"
            color="primary"
            startIcon={<IconLibrary.Reset />}
            onClick={() => formRef.current?.reset()}>
            {formatMessage({
              id: 'SERVICEPROVIDER_EDIT_RESET_PERFORMANCE_BUTTON',
              defaultMessage: 'Reset',
            })}
          </PermissionButton>
        </ButtonContainer>
      </Form>
    </PageSection>
  );
}
export default observer(Perfomance);
